"use client";
"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Clear = exports.ItemDelete = exports.ItemProgress = exports.ItemMetadata = exports.ItemPreview = exports.Item = exports.List = exports.Trigger = exports.Dropzone = exports.Root = exports.FileUploadClear = exports.FileUploadItemDelete = exports.FileUploadItemProgress = exports.FileUploadItemMetadata = exports.FileUploadItemPreview = exports.FileUploadItem = exports.FileUploadList = exports.FileUploadTrigger = exports.FileUploadDropzone = exports.FileUpload = void 0;
exports.useFileUpload = useStore;
var jsx_runtime_1 = require("react/jsx-runtime");
var utils_1 = require("@/lib/utils");
var react_slot_1 = require("@radix-ui/react-slot");
var lucide_react_1 = require("lucide-react");
var React = __importStar(require("react"));
var ROOT_NAME = "FileUpload";
var DROPZONE_NAME = "FileUploadDropzone";
var TRIGGER_NAME = "FileUploadTrigger";
var LIST_NAME = "FileUploadList";
var ITEM_NAME = "FileUploadItem";
var ITEM_PREVIEW_NAME = "FileUploadItemPreview";
var ITEM_METADATA_NAME = "FileUploadItemMetadata";
var ITEM_PROGRESS_NAME = "FileUploadItemProgress";
var ITEM_DELETE_NAME = "FileUploadItemDelete";
var CLEAR_NAME = "FileUploadClear";
var FILE_UPLOAD_ERRORS = (_a = {},
    _a[ROOT_NAME] = "`".concat(ROOT_NAME, "` must be used as root component"),
    _a[DROPZONE_NAME] = "`".concat(DROPZONE_NAME, "` must be within `").concat(ROOT_NAME, "`"),
    _a[TRIGGER_NAME] = "`".concat(TRIGGER_NAME, "` must be within `").concat(ROOT_NAME, "`"),
    _a[LIST_NAME] = "`".concat(LIST_NAME, "` must be within `").concat(ROOT_NAME, "`"),
    _a[ITEM_NAME] = "`".concat(ITEM_NAME, "` must be within `").concat(ROOT_NAME, "`"),
    _a[ITEM_PREVIEW_NAME] = "`".concat(ITEM_PREVIEW_NAME, "` must be within `").concat(ITEM_NAME, "`"),
    _a[ITEM_METADATA_NAME] = "`".concat(ITEM_METADATA_NAME, "` must be within `").concat(ITEM_NAME, "`"),
    _a[ITEM_PROGRESS_NAME] = "`".concat(ITEM_PROGRESS_NAME, "` must be within `").concat(ITEM_NAME, "`"),
    _a[ITEM_DELETE_NAME] = "`".concat(ITEM_DELETE_NAME, "` must be within `").concat(ITEM_NAME, "`"),
    _a[CLEAR_NAME] = "`".concat(CLEAR_NAME, "` must be within `").concat(ROOT_NAME, "`"),
    _a);
var useIsomorphicLayoutEffect = typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;
function useAsRef(data) {
    var ref = React.useRef(data);
    useIsomorphicLayoutEffect(function () {
        ref.current = data;
    });
    return ref;
}
function useLazyRef(fn) {
    var ref = React.useRef(null);
    if (ref.current === null) {
        ref.current = fn();
    }
    return ref;
}
var DirectionContext = React.createContext(undefined);
function useDirection(dirProp) {
    var _a;
    var contextDir = React.useContext(DirectionContext);
    return (_a = dirProp !== null && dirProp !== void 0 ? dirProp : contextDir) !== null && _a !== void 0 ? _a : "ltr";
}
function createStore(listeners, files, onValueChange, invalid) {
    var initialState = {
        files: files,
        dragOver: false,
        invalid: invalid !== null && invalid !== void 0 ? invalid : false,
    };
    var state = initialState;
    function reducer(state, action) {
        switch (action.variant) {
            case "ADD_FILES": {
                for (var _i = 0, _a = action.files; _i < _a.length; _i++) {
                    var file = _a[_i];
                    files.set(file, {
                        file: file,
                        progress: 0,
                        status: "idle",
                    });
                }
                if (onValueChange) {
                    var fileList = Array.from(files.values()).map(function (fileState) { return fileState.file; });
                    onValueChange(fileList);
                }
                return __assign(__assign({}, state), { files: files });
            }
            case "SET_FILES": {
                var newFileSet = new Set(action.files);
                for (var _b = 0, _c = files.keys(); _b < _c.length; _b++) {
                    var existingFile = _c[_b];
                    if (!newFileSet.has(existingFile)) {
                        files.delete(existingFile);
                    }
                }
                for (var _d = 0, _e = action.files; _d < _e.length; _d++) {
                    var file = _e[_d];
                    var existingState = files.get(file);
                    if (!existingState) {
                        files.set(file, {
                            file: file,
                            progress: 0,
                            status: "idle",
                        });
                    }
                }
                return __assign(__assign({}, state), { files: files });
            }
            case "SET_PROGRESS": {
                var fileState = files.get(action.file);
                if (fileState) {
                    files.set(action.file, __assign(__assign({}, fileState), { progress: action.progress, status: "uploading" }));
                }
                return __assign(__assign({}, state), { files: files });
            }
            case "SET_SUCCESS": {
                var fileState = files.get(action.file);
                if (fileState) {
                    files.set(action.file, __assign(__assign({}, fileState), { progress: 100, status: "success" }));
                }
                return __assign(__assign({}, state), { files: files });
            }
            case "SET_ERROR": {
                var fileState = files.get(action.file);
                if (fileState) {
                    files.set(action.file, __assign(__assign({}, fileState), { error: action.error, status: "error" }));
                }
                return __assign(__assign({}, state), { files: files });
            }
            case "REMOVE_FILE": {
                files.delete(action.file);
                if (onValueChange) {
                    var fileList = Array.from(files.values()).map(function (fileState) { return fileState.file; });
                    onValueChange(fileList);
                }
                return __assign(__assign({}, state), { files: files });
            }
            case "SET_DRAG_OVER": {
                return __assign(__assign({}, state), { dragOver: action.dragOver });
            }
            case "SET_INVALID": {
                return __assign(__assign({}, state), { invalid: action.invalid });
            }
            case "CLEAR": {
                files.clear();
                if (onValueChange) {
                    onValueChange([]);
                }
                return __assign(__assign({}, state), { files: files, invalid: false });
            }
            default:
                return state;
        }
    }
    function getState() {
        return state;
    }
    function dispatch(action) {
        state = reducer(state, action);
        for (var _i = 0, listeners_1 = listeners; _i < listeners_1.length; _i++) {
            var listener = listeners_1[_i];
            listener();
        }
    }
    function subscribe(listener) {
        listeners.add(listener);
        return function () { return listeners.delete(listener); };
    }
    return { getState: getState, dispatch: dispatch, subscribe: subscribe };
}
var StoreContext = React.createContext(null);
StoreContext.displayName = ROOT_NAME;
function useStoreContext(name) {
    var context = React.useContext(StoreContext);
    if (!context) {
        throw new Error(FILE_UPLOAD_ERRORS[name]);
    }
    return context;
}
function useStore(selector) {
    var store = useStoreContext(ROOT_NAME);
    var lastValueRef = useLazyRef(function () { return null; });
    var getSnapshot = React.useCallback(function () {
        var state = store.getState();
        var prevValue = lastValueRef.current;
        if (prevValue && prevValue.state === state) {
            return prevValue.value;
        }
        var nextValue = selector(state);
        lastValueRef.current = { value: nextValue, state: state };
        return nextValue;
    }, [store, selector, lastValueRef]);
    return React.useSyncExternalStore(store.subscribe, getSnapshot, getSnapshot);
}
var FileUploadContext = React.createContext(null);
function useFileUploadContext(name) {
    var context = React.useContext(FileUploadContext);
    if (!context) {
        throw new Error(FILE_UPLOAD_ERRORS[name]);
    }
    return context;
}
var FileUploadRoot = React.forwardRef(function (props, forwardedRef) {
    var value = props.value, defaultValue = props.defaultValue, onValueChange = props.onValueChange, onAccept = props.onAccept, onFileAccept = props.onFileAccept, onFileReject = props.onFileReject, onFileValidate = props.onFileValidate, onUpload = props.onUpload, accept = props.accept, maxFiles = props.maxFiles, maxSize = props.maxSize, dirProp = props.dir, label = props.label, name = props.name, asChild = props.asChild, _a = props.disabled, disabled = _a === void 0 ? false : _a, _b = props.invalid, invalid = _b === void 0 ? false : _b, _c = props.multiple, multiple = _c === void 0 ? false : _c, _d = props.required, required = _d === void 0 ? false : _d, children = props.children, className = props.className, rootProps = __rest(props, ["value", "defaultValue", "onValueChange", "onAccept", "onFileAccept", "onFileReject", "onFileValidate", "onUpload", "accept", "maxFiles", "maxSize", "dir", "label", "name", "asChild", "disabled", "invalid", "multiple", "required", "children", "className"]);
    var inputId = React.useId();
    var dropzoneId = React.useId();
    var listId = React.useId();
    var labelId = React.useId();
    var dir = useDirection(dirProp);
    var propsRef = useAsRef(props);
    var listeners = useLazyRef(function () { return new Set(); }).current;
    var files = useLazyRef(function () { return new Map(); }).current;
    var inputRef = React.useRef(null);
    var isControlled = value !== undefined;
    var store = React.useMemo(function () { return createStore(listeners, files, onValueChange, invalid); }, [listeners, files, onValueChange, invalid]);
    var contextValue = React.useMemo(function () { return ({
        dropzoneId: dropzoneId,
        inputId: inputId,
        listId: listId,
        labelId: labelId,
        dir: dir,
        disabled: disabled,
        inputRef: inputRef,
    }); }, [dropzoneId, inputId, listId, labelId, dir, disabled]);
    React.useEffect(function () {
        if (isControlled) {
            store.dispatch({ variant: "SET_FILES", files: value });
        }
        else if (defaultValue &&
            defaultValue.length > 0 &&
            !store.getState().files.size) {
            store.dispatch({ variant: "SET_FILES", files: defaultValue });
        }
    }, [value, defaultValue, isControlled, store]);
    var onFilesChange = React.useCallback(function (originalFiles) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (propsRef.current.disabled)
            return;
        var filesToProcess = __spreadArray([], originalFiles, true);
        var invalid = false;
        if (propsRef.current.maxFiles) {
            var currentCount = store.getState().files.size;
            var remainingSlotCount = Math.max(0, propsRef.current.maxFiles - currentCount);
            if (remainingSlotCount < filesToProcess.length) {
                var rejectedFiles_2 = filesToProcess.slice(remainingSlotCount);
                invalid = true;
                filesToProcess = filesToProcess.slice(0, remainingSlotCount);
                for (var _i = 0, rejectedFiles_1 = rejectedFiles_2; _i < rejectedFiles_1.length; _i++) {
                    var file = rejectedFiles_1[_i];
                    var rejectionMessage = "Maximum ".concat(propsRef.current.maxFiles, " files allowed");
                    if (propsRef.current.onFileValidate) {
                        var validationMessage = propsRef.current.onFileValidate(file);
                        if (validationMessage) {
                            rejectionMessage = validationMessage;
                        }
                    }
                    (_b = (_a = propsRef.current).onFileReject) === null || _b === void 0 ? void 0 : _b.call(_a, file, rejectionMessage);
                }
            }
        }
        var acceptedFiles = [];
        var rejectedFiles = [];
        var _loop_1 = function (file) {
            var rejected = false;
            var rejectionMessage = "";
            if (propsRef.current.onFileValidate) {
                var validationMessage = propsRef.current.onFileValidate(file);
                if (validationMessage) {
                    rejectionMessage = validationMessage;
                    (_d = (_c = propsRef.current).onFileReject) === null || _d === void 0 ? void 0 : _d.call(_c, file, rejectionMessage);
                    rejected = true;
                    invalid = true;
                    return "continue";
                }
            }
            if (propsRef.current.accept) {
                var acceptTypes = propsRef.current.accept
                    .split(",")
                    .map(function (t) { return t.trim(); });
                var fileType_1 = file.type;
                var fileExtension_1 = ".".concat(file.name.split(".").pop());
                if (!acceptTypes.some(function (type) {
                    return type === fileType_1 ||
                        type === fileExtension_1 ||
                        (type.includes("/*") &&
                            fileType_1.startsWith(type.replace("/*", "/")));
                })) {
                    rejectionMessage = "File type not accepted";
                    (_f = (_e = propsRef.current).onFileReject) === null || _f === void 0 ? void 0 : _f.call(_e, file, rejectionMessage);
                    rejected = true;
                    invalid = true;
                }
            }
            if (propsRef.current.maxSize &&
                file.size > propsRef.current.maxSize) {
                rejectionMessage = "File too large";
                (_h = (_g = propsRef.current).onFileReject) === null || _h === void 0 ? void 0 : _h.call(_g, file, rejectionMessage);
                rejected = true;
                invalid = true;
            }
            if (!rejected) {
                acceptedFiles.push(file);
            }
            else {
                rejectedFiles.push({ file: file, message: rejectionMessage });
            }
        };
        for (var _l = 0, filesToProcess_1 = filesToProcess; _l < filesToProcess_1.length; _l++) {
            var file = filesToProcess_1[_l];
            _loop_1(file);
        }
        if (invalid) {
            store.dispatch({ variant: "SET_INVALID", invalid: invalid });
            setTimeout(function () {
                store.dispatch({ variant: "SET_INVALID", invalid: false });
            }, 2000);
        }
        if (acceptedFiles.length > 0) {
            store.dispatch({ variant: "ADD_FILES", files: acceptedFiles });
            if (isControlled && propsRef.current.onValueChange) {
                var currentFiles = Array.from(store.getState().files.values()).map(function (f) { return f.file; });
                propsRef.current.onValueChange(__spreadArray([], currentFiles, true));
            }
            if (propsRef.current.onAccept) {
                propsRef.current.onAccept(acceptedFiles);
            }
            for (var _m = 0, acceptedFiles_1 = acceptedFiles; _m < acceptedFiles_1.length; _m++) {
                var file = acceptedFiles_1[_m];
                (_k = (_j = propsRef.current).onFileAccept) === null || _k === void 0 ? void 0 : _k.call(_j, file);
            }
            if (propsRef.current.onUpload) {
                requestAnimationFrame(function () {
                    onFilesUpload(acceptedFiles);
                });
            }
        }
    }, [store, isControlled, propsRef]);
    var onFilesUpload = React.useCallback(function (files) { return __awaiter(void 0, void 0, void 0, function () {
        var _i, files_1, file, _a, files_2, file, error_1, errorMessage, _b, files_3, file;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 4, , 5]);
                    for (_i = 0, files_1 = files; _i < files_1.length; _i++) {
                        file = files_1[_i];
                        store.dispatch({ variant: "SET_PROGRESS", file: file, progress: 0 });
                    }
                    if (!propsRef.current.onUpload) return [3 /*break*/, 2];
                    return [4 /*yield*/, propsRef.current.onUpload(files, {
                            onProgress: function (file, progress) {
                                store.dispatch({
                                    variant: "SET_PROGRESS",
                                    file: file,
                                    progress: Math.min(Math.max(0, progress), 100),
                                });
                            },
                            onSuccess: function (file) {
                                store.dispatch({ variant: "SET_SUCCESS", file: file });
                            },
                            onError: function (file, error) {
                                var _a;
                                store.dispatch({
                                    variant: "SET_ERROR",
                                    file: file,
                                    error: (_a = error.message) !== null && _a !== void 0 ? _a : "Upload failed",
                                });
                            },
                        })];
                case 1:
                    _c.sent();
                    return [3 /*break*/, 3];
                case 2:
                    for (_a = 0, files_2 = files; _a < files_2.length; _a++) {
                        file = files_2[_a];
                        store.dispatch({ variant: "SET_SUCCESS", file: file });
                    }
                    _c.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    error_1 = _c.sent();
                    errorMessage = error_1 instanceof Error ? error_1.message : "Upload failed";
                    for (_b = 0, files_3 = files; _b < files_3.length; _b++) {
                        file = files_3[_b];
                        store.dispatch({
                            variant: "SET_ERROR",
                            file: file,
                            error: errorMessage,
                        });
                    }
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [store, propsRef.current.onUpload]);
    var onInputChange = React.useCallback(function (event) {
        var _a;
        var files = Array.from((_a = event.target.files) !== null && _a !== void 0 ? _a : []);
        onFilesChange(files);
        event.target.value = "";
    }, [onFilesChange]);
    var RootPrimitive = asChild ? react_slot_1.Slot : "div";
    return ((0, jsx_runtime_1.jsx)(DirectionContext.Provider, { value: dir, children: (0, jsx_runtime_1.jsx)(StoreContext.Provider, { value: store, children: (0, jsx_runtime_1.jsx)(FileUploadContext.Provider, { value: contextValue, children: (0, jsx_runtime_1.jsxs)(RootPrimitive, __assign({ "data-disabled": disabled ? "" : undefined, "data-slot": "file-upload", dir: dir }, rootProps, { ref: forwardedRef, className: (0, utils_1.cn)("relative flex flex-col gap-2", className), children: [children, (0, jsx_runtime_1.jsx)("input", { type: "file", id: inputId, "aria-labelledby": labelId, "aria-describedby": dropzoneId, ref: inputRef, tabIndex: -1, accept: accept, name: name, disabled: disabled, multiple: multiple, required: required, className: "sr-only", onChange: onInputChange }), (0, jsx_runtime_1.jsx)("span", { id: labelId, className: "sr-only", children: label !== null && label !== void 0 ? label : "File upload" })] })) }) }) }));
});
FileUploadRoot.displayName = ROOT_NAME;
var FileUploadDropzone = React.forwardRef(function (props, forwardedRef) {
    var asChild = props.asChild, className = props.className, dropzoneProps = __rest(props, ["asChild", "className"]);
    var context = useFileUploadContext(DROPZONE_NAME);
    var store = useStoreContext(DROPZONE_NAME);
    var dragOver = useStore(function (state) { return state.dragOver; });
    var invalid = useStore(function (state) { return state.invalid; });
    var propsRef = useAsRef(dropzoneProps);
    var onClick = React.useCallback(function (event) {
        var _a, _b, _c;
        (_b = (_a = propsRef.current) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        if (event.defaultPrevented)
            return;
        var target = event.target;
        var isFromTrigger = target instanceof HTMLElement &&
            target.closest('[data-slot="file-upload-trigger"]');
        if (!isFromTrigger) {
            (_c = context.inputRef.current) === null || _c === void 0 ? void 0 : _c.click();
        }
    }, [context.inputRef, propsRef]);
    var onDragOver = React.useCallback(function (event) {
        var _a, _b;
        (_b = (_a = propsRef.current) === null || _a === void 0 ? void 0 : _a.onDragOver) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        if (event.defaultPrevented)
            return;
        event.preventDefault();
        store.dispatch({ variant: "SET_DRAG_OVER", dragOver: true });
    }, [store, propsRef.current.onDragOver]);
    var onDragEnter = React.useCallback(function (event) {
        var _a, _b;
        (_b = (_a = propsRef.current) === null || _a === void 0 ? void 0 : _a.onDragEnter) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        if (event.defaultPrevented)
            return;
        event.preventDefault();
        store.dispatch({ variant: "SET_DRAG_OVER", dragOver: true });
    }, [store, propsRef.current.onDragEnter]);
    var onDragLeave = React.useCallback(function (event) {
        var _a, _b;
        (_b = (_a = propsRef.current) === null || _a === void 0 ? void 0 : _a.onDragLeave) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        if (event.defaultPrevented)
            return;
        var relatedTarget = event.relatedTarget;
        if (relatedTarget &&
            relatedTarget instanceof Node &&
            event.currentTarget.contains(relatedTarget)) {
            return;
        }
        event.preventDefault();
        store.dispatch({ variant: "SET_DRAG_OVER", dragOver: false });
    }, [store, propsRef.current.onDragLeave]);
    var onDrop = React.useCallback(function (event) {
        var _a, _b;
        (_b = (_a = propsRef.current) === null || _a === void 0 ? void 0 : _a.onDrop) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        if (event.defaultPrevented)
            return;
        event.preventDefault();
        store.dispatch({ variant: "SET_DRAG_OVER", dragOver: false });
        var files = Array.from(event.dataTransfer.files);
        var inputElement = context.inputRef.current;
        if (!inputElement)
            return;
        var dataTransfer = new DataTransfer();
        for (var _i = 0, files_4 = files; _i < files_4.length; _i++) {
            var file = files_4[_i];
            dataTransfer.items.add(file);
        }
        inputElement.files = dataTransfer.files;
        inputElement.dispatchEvent(new Event("change", { bubbles: true }));
    }, [store, context.inputRef, propsRef.current.onDrop]);
    var onPaste = React.useCallback(function (event) {
        var _a, _b, _c;
        (_b = (_a = propsRef.current) === null || _a === void 0 ? void 0 : _a.onPaste) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        if (event.defaultPrevented)
            return;
        event.preventDefault();
        store.dispatch({ variant: "SET_DRAG_OVER", dragOver: false });
        var items = (_c = event.clipboardData) === null || _c === void 0 ? void 0 : _c.items;
        if (!items)
            return;
        var files = [];
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if ((item === null || item === void 0 ? void 0 : item.kind) === "file") {
                var file = item.getAsFile();
                if (file) {
                    files.push(file);
                }
            }
        }
        if (files.length === 0)
            return;
        var inputElement = context.inputRef.current;
        if (!inputElement)
            return;
        var dataTransfer = new DataTransfer();
        for (var _i = 0, files_5 = files; _i < files_5.length; _i++) {
            var file = files_5[_i];
            dataTransfer.items.add(file);
        }
        inputElement.files = dataTransfer.files;
        inputElement.dispatchEvent(new Event("change", { bubbles: true }));
    }, [store, context.inputRef, propsRef]);
    var onKeyDown = React.useCallback(function (event) {
        var _a, _b, _c;
        (_b = (_a = propsRef.current) === null || _a === void 0 ? void 0 : _a.onKeyDown) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        if (!event.defaultPrevented &&
            (event.key === "Enter" || event.key === " ")) {
            event.preventDefault();
            (_c = context.inputRef.current) === null || _c === void 0 ? void 0 : _c.click();
        }
    }, [context.inputRef, propsRef.current.onKeyDown]);
    var DropzonePrimitive = asChild ? react_slot_1.Slot : "div";
    return ((0, jsx_runtime_1.jsx)(DropzonePrimitive, __assign({ role: "region", id: context.dropzoneId, "aria-controls": "".concat(context.inputId, " ").concat(context.listId), "aria-disabled": context.disabled, "aria-invalid": invalid, "data-disabled": context.disabled ? "" : undefined, "data-dragging": dragOver ? "" : undefined, "data-invalid": invalid ? "" : undefined, "data-slot": "file-upload-dropzone", dir: context.dir, tabIndex: context.disabled ? undefined : 0 }, dropzoneProps, { ref: forwardedRef, className: (0, utils_1.cn)("relative flex select-none flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed p-6 outline-none transition-colors hover:bg-accent/30 focus-visible:border-ring/50 data-[disabled]:pointer-events-none data-[dragging]:border-primary data-[invalid]:border-destructive data-[invalid]:ring-destructive/20", className), onClick: onClick, onDragEnter: onDragEnter, onDragLeave: onDragLeave, onDragOver: onDragOver, onDrop: onDrop, onKeyDown: onKeyDown, onPaste: onPaste })));
});
exports.FileUploadDropzone = FileUploadDropzone;
FileUploadDropzone.displayName = DROPZONE_NAME;
var FileUploadTrigger = React.forwardRef(function (props, forwardedRef) {
    var asChild = props.asChild, triggerProps = __rest(props, ["asChild"]);
    var context = useFileUploadContext(TRIGGER_NAME);
    var propsRef = useAsRef(triggerProps);
    var onClick = React.useCallback(function (event) {
        var _a, _b, _c;
        (_b = (_a = propsRef.current) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        if (event.defaultPrevented)
            return;
        (_c = context.inputRef.current) === null || _c === void 0 ? void 0 : _c.click();
    }, [context.inputRef, propsRef.current]);
    var TriggerPrimitive = asChild ? react_slot_1.Slot : "button";
    return ((0, jsx_runtime_1.jsx)(TriggerPrimitive, __assign({ type: "button", "aria-controls": context.inputId, "data-disabled": context.disabled ? "" : undefined, "data-slot": "file-upload-trigger" }, triggerProps, { ref: forwardedRef, disabled: context.disabled, onClick: onClick })));
});
exports.FileUploadTrigger = FileUploadTrigger;
FileUploadTrigger.displayName = TRIGGER_NAME;
var FileUploadList = React.forwardRef(function (props, forwardedRef) {
    var className = props.className, _a = props.orientation, orientation = _a === void 0 ? "vertical" : _a, asChild = props.asChild, forceMount = props.forceMount, listProps = __rest(props, ["className", "orientation", "asChild", "forceMount"]);
    var context = useFileUploadContext(LIST_NAME);
    var shouldRender = forceMount || useStore(function (state) { return state.files.size > 0; });
    if (!shouldRender)
        return null;
    var ListPrimitive = asChild ? react_slot_1.Slot : "div";
    return ((0, jsx_runtime_1.jsx)(ListPrimitive, __assign({ role: "list", id: context.listId, "aria-orientation": orientation, "data-orientation": orientation, "data-slot": "file-upload-list", "data-state": shouldRender ? "active" : "inactive", dir: context.dir }, listProps, { ref: forwardedRef, className: (0, utils_1.cn)("data-[state=inactive]:fade-out-0 data-[state=active]:fade-in-0 data-[state=inactive]:slide-out-to-top-2 data-[state=active]:slide-in-from-top-2 flex flex-col gap-2 data-[state=active]:animate-in data-[state=inactive]:animate-out", orientation === "horizontal" && "flex-row overflow-x-auto p-1.5", className) })));
});
exports.FileUploadList = FileUploadList;
FileUploadList.displayName = LIST_NAME;
var FileUploadItemContext = React.createContext(null);
function useFileUploadItemContext(name) {
    var context = React.useContext(FileUploadItemContext);
    if (!context) {
        throw new Error(FILE_UPLOAD_ERRORS[name]);
    }
    return context;
}
var FileUploadItem = React.forwardRef(function (props, forwardedRef) {
    var value = props.value, asChild = props.asChild, className = props.className, itemProps = __rest(props, ["value", "asChild", "className"]);
    var id = React.useId();
    var statusId = "".concat(id, "-status");
    var nameId = "".concat(id, "-name");
    var sizeId = "".concat(id, "-size");
    var messageId = "".concat(id, "-message");
    var context = useFileUploadContext(ITEM_NAME);
    var fileState = useStore(function (state) { return state.files.get(value); });
    var fileCount = useStore(function (state) { return state.files.size; });
    var fileIndex = useStore(function (state) {
        var files = Array.from(state.files.keys());
        return files.indexOf(value) + 1;
    });
    var itemContext = React.useMemo(function () { return ({
        id: id,
        fileState: fileState,
        nameId: nameId,
        sizeId: sizeId,
        statusId: statusId,
        messageId: messageId,
    }); }, [id, fileState, statusId, nameId, sizeId, messageId]);
    if (!fileState)
        return null;
    var statusText = fileState.error
        ? "Error: ".concat(fileState.error)
        : fileState.status === "uploading"
            ? "Uploading: ".concat(fileState.progress, "% complete")
            : fileState.status === "success"
                ? "Upload complete"
                : "Ready to upload";
    var ItemPrimitive = asChild ? react_slot_1.Slot : "div";
    return ((0, jsx_runtime_1.jsx)(FileUploadItemContext.Provider, { value: itemContext, children: (0, jsx_runtime_1.jsxs)(ItemPrimitive, __assign({ role: "listitem", id: id, "aria-setsize": fileCount, "aria-posinset": fileIndex, "aria-describedby": "".concat(nameId, " ").concat(sizeId, " ").concat(statusId, " ").concat(fileState.error ? messageId : ""), "aria-labelledby": nameId, "data-slot": "file-upload-item", dir: context.dir }, itemProps, { ref: forwardedRef, className: (0, utils_1.cn)("relative flex items-center gap-2.5 rounded-md border p-3", className), children: [props.children, (0, jsx_runtime_1.jsx)("span", { id: statusId, className: "sr-only", children: statusText })] })) }));
});
exports.FileUploadItem = FileUploadItem;
FileUploadItem.displayName = ITEM_NAME;
function formatBytes(bytes) {
    if (bytes === 0)
        return "0 B";
    var sizes = ["B", "KB", "MB", "GB", "TB"];
    var i = Math.floor(Math.log(bytes) / Math.log(1024));
    return "".concat((bytes / Math.pow(1024, i)).toFixed(i ? 1 : 0), " ").concat(sizes[i]);
}
function getFileIcon(file) {
    var _a, _b;
    var type = file.type;
    var extension = (_b = (_a = file.name.split(".").pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "";
    if (type.startsWith("video/")) {
        return (0, jsx_runtime_1.jsx)(lucide_react_1.FileVideoIcon, {});
    }
    if (type.startsWith("audio/")) {
        return (0, jsx_runtime_1.jsx)(lucide_react_1.FileAudioIcon, {});
    }
    if (type.startsWith("text/") ||
        ["txt", "md", "rtf", "pdf"].includes(extension)) {
        return (0, jsx_runtime_1.jsx)(lucide_react_1.FileTextIcon, {});
    }
    if ([
        "html",
        "css",
        "js",
        "jsx",
        "ts",
        "tsx",
        "json",
        "xml",
        "php",
        "py",
        "rb",
        "java",
        "c",
        "cpp",
        "cs",
    ].includes(extension)) {
        return (0, jsx_runtime_1.jsx)(lucide_react_1.FileCodeIcon, {});
    }
    if (["zip", "rar", "7z", "tar", "gz", "bz2"].includes(extension)) {
        return (0, jsx_runtime_1.jsx)(lucide_react_1.FileArchiveIcon, {});
    }
    if (["exe", "msi", "app", "apk", "deb", "rpm"].includes(extension) ||
        type.startsWith("application/")) {
        return (0, jsx_runtime_1.jsx)(lucide_react_1.FileCogIcon, {});
    }
    return (0, jsx_runtime_1.jsx)(lucide_react_1.FileIcon, {});
}
var FileUploadItemPreview = React.forwardRef(function (props, forwardedRef) {
    var _a;
    var render = props.render, asChild = props.asChild, children = props.children, className = props.className, previewProps = __rest(props, ["render", "asChild", "children", "className"]);
    var itemContext = useFileUploadItemContext(ITEM_PREVIEW_NAME);
    var onPreviewRender = React.useCallback(function (file) {
        var _a;
        if (render)
            return render(file);
        if ((_a = itemContext.fileState) === null || _a === void 0 ? void 0 : _a.file.type.startsWith("image/")) {
            return ((0, jsx_runtime_1.jsx)("img", { src: URL.createObjectURL(file), alt: file.name, className: "size-full object-cover", onLoad: function (event) {
                    if (!(event.target instanceof HTMLImageElement))
                        return;
                    URL.revokeObjectURL(event.target.src);
                } }));
        }
        return getFileIcon(file);
    }, [render, (_a = itemContext.fileState) === null || _a === void 0 ? void 0 : _a.file.type]);
    if (!itemContext.fileState)
        return null;
    var ItemPreviewPrimitive = asChild ? react_slot_1.Slot : "div";
    return ((0, jsx_runtime_1.jsxs)(ItemPreviewPrimitive, __assign({ "aria-labelledby": itemContext.nameId, "data-slot": "file-upload-preview" }, previewProps, { ref: forwardedRef, className: (0, utils_1.cn)("relative flex size-10 shrink-0 items-center justify-center overflow-hidden rounded border bg-accent/50 [&>svg]:size-10", className), children: [onPreviewRender(itemContext.fileState.file), children] })));
});
exports.FileUploadItemPreview = FileUploadItemPreview;
FileUploadItemPreview.displayName = ITEM_PREVIEW_NAME;
var FileUploadItemMetadata = React.forwardRef(function (props, forwardedRef) {
    var asChild = props.asChild, _a = props.size, size = _a === void 0 ? "default" : _a, children = props.children, className = props.className, metadataProps = __rest(props, ["asChild", "size", "children", "className"]);
    var context = useFileUploadContext(ITEM_METADATA_NAME);
    var itemContext = useFileUploadItemContext(ITEM_METADATA_NAME);
    if (!itemContext.fileState)
        return null;
    var ItemMetadataPrimitive = asChild ? react_slot_1.Slot : "div";
    return ((0, jsx_runtime_1.jsx)(ItemMetadataPrimitive, __assign({ "data-slot": "file-upload-metadata", dir: context.dir }, metadataProps, { ref: forwardedRef, className: (0, utils_1.cn)("flex min-w-0 flex-1 flex-col", className), children: children !== null && children !== void 0 ? children : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { id: itemContext.nameId, className: (0, utils_1.cn)("truncate font-medium text-sm", size === "sm" && "font-normal text-[13px] leading-snug"), children: itemContext.fileState.file.name }), (0, jsx_runtime_1.jsx)("span", { id: itemContext.sizeId, className: (0, utils_1.cn)("truncate text-muted-foreground text-xs", size === "sm" && "text-[11px]"), children: formatBytes(itemContext.fileState.file.size) }), itemContext.fileState.error && ((0, jsx_runtime_1.jsx)("span", { id: itemContext.messageId, className: "text-destructive text-xs", children: itemContext.fileState.error }))] })) })));
});
exports.FileUploadItemMetadata = FileUploadItemMetadata;
FileUploadItemMetadata.displayName = ITEM_METADATA_NAME;
var FileUploadItemProgress = React.forwardRef(function (props, forwardedRef) {
    var _a = props.variant, variant = _a === void 0 ? "linear" : _a, _b = props.size, size = _b === void 0 ? 40 : _b, asChild = props.asChild, forceMount = props.forceMount, className = props.className, progressProps = __rest(props, ["variant", "size", "asChild", "forceMount", "className"]);
    var itemContext = useFileUploadItemContext(ITEM_PROGRESS_NAME);
    if (!itemContext.fileState)
        return null;
    var shouldRender = forceMount || itemContext.fileState.progress !== 100;
    if (!shouldRender)
        return null;
    var ItemProgressPrimitive = asChild ? react_slot_1.Slot : "div";
    switch (variant) {
        case "circular": {
            var circumference = 2 * Math.PI * ((size - 4) / 2);
            var strokeDashoffset = circumference - (itemContext.fileState.progress / 100) * circumference;
            return ((0, jsx_runtime_1.jsx)(ItemProgressPrimitive, __assign({ role: "progressbar", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": itemContext.fileState.progress, "aria-valuetext": "".concat(itemContext.fileState.progress, "%"), "aria-labelledby": itemContext.nameId, "data-slot": "file-upload-progress" }, progressProps, { ref: forwardedRef, className: (0, utils_1.cn)("-translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2", className), children: (0, jsx_runtime_1.jsxs)("svg", { className: "rotate-[-90deg] transform", width: size, height: size, viewBox: "0 0 ".concat(size, " ").concat(size), fill: "none", stroke: "currentColor", children: [(0, jsx_runtime_1.jsx)("circle", { className: "text-primary/20", strokeWidth: "2", cx: size / 2, cy: size / 2, r: (size - 4) / 2 }), (0, jsx_runtime_1.jsx)("circle", { className: "text-primary transition-[stroke-dashoffset] duration-300 ease-linear", strokeWidth: "2", strokeLinecap: "round", strokeDasharray: circumference, strokeDashoffset: strokeDashoffset, cx: size / 2, cy: size / 2, r: (size - 4) / 2 })] }) })));
        }
        case "fill": {
            var progressPercentage = itemContext.fileState.progress;
            var topInset = 100 - progressPercentage;
            return ((0, jsx_runtime_1.jsx)(ItemProgressPrimitive, __assign({ role: "progressbar", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": progressPercentage, "aria-valuetext": "".concat(progressPercentage, "%"), "aria-labelledby": itemContext.nameId, "data-slot": "file-upload-progress" }, progressProps, { ref: forwardedRef, className: (0, utils_1.cn)("absolute inset-0 bg-primary/50 transition-[clip-path] duration-300 ease-linear", className), style: {
                    clipPath: "inset(".concat(topInset, "% 0% 0% 0%)"),
                } })));
        }
        default:
            return ((0, jsx_runtime_1.jsx)(ItemProgressPrimitive, __assign({ role: "progressbar", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": itemContext.fileState.progress, "aria-valuetext": "".concat(itemContext.fileState.progress, "%"), "aria-labelledby": itemContext.nameId, "data-slot": "file-upload-progress" }, progressProps, { ref: forwardedRef, className: (0, utils_1.cn)("relative h-1.5 w-full overflow-hidden rounded-full bg-primary/20", className), children: (0, jsx_runtime_1.jsx)("div", { className: "h-full w-full flex-1 bg-primary transition-transform duration-300 ease-linear", style: {
                        transform: "translateX(-".concat(100 - itemContext.fileState.progress, "%)"),
                    } }) })));
    }
});
exports.FileUploadItemProgress = FileUploadItemProgress;
FileUploadItemProgress.displayName = ITEM_PROGRESS_NAME;
var FileUploadItemDelete = React.forwardRef(function (props, forwardedRef) {
    var _a;
    var asChild = props.asChild, deleteProps = __rest(props, ["asChild"]);
    var store = useStoreContext(ITEM_DELETE_NAME);
    var itemContext = useFileUploadItemContext(ITEM_DELETE_NAME);
    var propsRef = useAsRef(deleteProps);
    var onClick = React.useCallback(function (event) {
        var _a, _b;
        (_b = (_a = propsRef.current) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        if (!itemContext.fileState || event.defaultPrevented)
            return;
        store.dispatch({
            variant: "REMOVE_FILE",
            file: itemContext.fileState.file,
        });
    }, [store, itemContext.fileState, (_a = propsRef.current) === null || _a === void 0 ? void 0 : _a.onClick]);
    if (!itemContext.fileState)
        return null;
    var ItemDeletePrimitive = asChild ? react_slot_1.Slot : "button";
    return ((0, jsx_runtime_1.jsx)(ItemDeletePrimitive, __assign({ type: "button", "aria-controls": itemContext.id, "aria-describedby": itemContext.nameId, "data-slot": "file-upload-item-delete" }, deleteProps, { ref: forwardedRef, onClick: onClick })));
});
exports.FileUploadItemDelete = FileUploadItemDelete;
FileUploadItemDelete.displayName = ITEM_DELETE_NAME;
var FileUploadClear = React.forwardRef(function (props, forwardedRef) {
    var asChild = props.asChild, forceMount = props.forceMount, disabled = props.disabled, clearProps = __rest(props, ["asChild", "forceMount", "disabled"]);
    var context = useFileUploadContext(CLEAR_NAME);
    var store = useStoreContext(CLEAR_NAME);
    var propsRef = useAsRef(clearProps);
    var isDisabled = disabled || context.disabled;
    var onClick = React.useCallback(function (event) {
        var _a, _b;
        (_b = (_a = propsRef.current) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        if (event.defaultPrevented)
            return;
        store.dispatch({ variant: "CLEAR" });
    }, [store, propsRef]);
    var shouldRender = forceMount || useStore(function (state) { return state.files.size > 0; });
    if (!shouldRender)
        return null;
    var ClearPrimitive = asChild ? react_slot_1.Slot : "button";
    return ((0, jsx_runtime_1.jsx)(ClearPrimitive, __assign({ type: "button", "aria-controls": context.listId, "data-slot": "file-upload-clear", "data-disabled": isDisabled ? "" : undefined }, clearProps, { ref: forwardedRef, disabled: isDisabled, onClick: onClick })));
});
exports.FileUploadClear = FileUploadClear;
FileUploadClear.displayName = CLEAR_NAME;
var FileUpload = FileUploadRoot;
exports.FileUpload = FileUpload;
var Root = FileUploadRoot;
exports.Root = Root;
var Trigger = FileUploadTrigger;
exports.Trigger = Trigger;
var Dropzone = FileUploadDropzone;
exports.Dropzone = Dropzone;
var List = FileUploadList;
exports.List = List;
var Item = FileUploadItem;
exports.Item = Item;
var ItemPreview = FileUploadItemPreview;
exports.ItemPreview = ItemPreview;
var ItemMetadata = FileUploadItemMetadata;
exports.ItemMetadata = ItemMetadata;
var ItemProgress = FileUploadItemProgress;
exports.ItemProgress = ItemProgress;
var ItemDelete = FileUploadItemDelete;
exports.ItemDelete = ItemDelete;
var Clear = FileUploadClear;
exports.Clear = Clear;
